import util from '../util'

let controller = 'Operadores'
export default Object.assign({}, util.GetCrud(controller, null), {
  SolicitarLinkSenha: function (dto) {
    return util.Axios.Post(controller + '/SolicitarLinkSenha', dto)
  },
  RecuperarSenha: function (dto) {
    return util.Axios.Post(controller + '/RecuperarSenha', dto)
  },
  ValidaTokenSenha: function (username, token) {
    let params = { username: username, token: token }
    return util.Axios.GetParams(controller + '/ValidaTokenSenha', params)
  },
  Combo: function () {
    return util.Axios.Get(controller + '/Combo')
  },
  GetAcessoUsuario: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + "/GetAcessoUsuario", dto)
  },
  AtivarUsuario: function (id) {
    return util.Axios.Post(controller + `/PostAtivarUsuario?codigoUsuario=${id}`, {})
  },
  IntegrarUsuarioSSO: function (id) {
    return util.Axios.Post(controller + `/IntegrarUsuarioSSO?codigoUsuario=${id}`, {})
  },
  ResetarMfaFisico: function (id) {
    return util.Axios.Post(controller + `/mfafisico/resetar?codigoUsuario=${id}`, {})
  },
  SolicitarRegistroMfaFisico: function (email) {
    return util.Axios.Post(controller + `/mfafisico/solicitar/${email}`, {})
  },
  RegistrarMfaFisico: function (dto) {
    return util.Axios.Post(controller + '/mfafisico/registrar', dto)
  }
})
